import React from 'react';
import { Avatar, Box, CircularProgress, Divider, Tooltip, Typography, useMediaQuery } from "@mui/material";
import { HomeOutlined, QueryBuilderOutlined, PersonAddOutlined, LogoutOutlined, Approval, TableChart, MenuBookOutlined } from '@mui/icons-material';

import SidebarItem from './SidebarItem';
import { useSelector } from 'react-redux';
import { get_auth_process_states, get_auth_user_data } from '../../../redux/auth/auth.selectors';
import { useDispatch } from 'react-redux';
import { logout_dispatch } from '../../../redux/auth/auth.actions';
import { useTheme } from '@emotion/react';

const sidebarItems = [
  {
    title: 'Home',
    path: '/',
    icon: <HomeOutlined />,
    alternative_path: ["/",],
    roles: ["planner",],
  },
  {
    title: 'Test Schedule',
    path: '/output',
    icon: <QueryBuilderOutlined />,
    roles: ["planner", "admin"],
  },
  // {
  //   title: 'Insights',
  //   path: '/insights',
  //   icon: <TrendingUpOutlined />,
  // },
  {
    title: 'Approval & UD',
    path: '/approval_ud',
    icon: <Approval />,
    hidden: true,
    roles: ["planner",],
  },
  // {
  //   title: 'Alerts & Updates',
  //   path: '/alerts',
  //   icon: <NotificationsOutlined />,
  // },
  {
    title: 'Master Sheet',
    path: '/master-sheet',
    icon: <TableChart />,
    roles: ["planner"],
    hidden: false,
  },
  {
    title: 'Users & Roles',
    path: '/',
    icon: <PersonAddOutlined />,
    roles: ["admin"],
    hidden: false,
  },
];

const Sidebar = ({ sidebar_opened }) => {

  const dispatch = useDispatch();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const { name, role } = useSelector(get_auth_user_data);
  const { auth_process_loading } = useSelector(get_auth_process_states);

  if (isMobile && !sidebar_opened) {
    return null;
  }

  return (
    <>
      <Box
        sx={{
          // border: '1px solid blue',
          width: {
            xs: !sidebar_opened ? "0%" : "100%",
            sm: !sidebar_opened ? "50px" : "250px"
          },
          overflowY: 'auto',
          position: "relative",
          // boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)", // Added box shadow to the right side
          transition: "width 0.3s ease-in-out", // Add this line to add a transition effect
          "& *": { // This rule applies to all children of the Box
            transition: "all 0.3s ease-in-out"
          },
          // boxShadow: 'inset -2px 0 4px rgba(0, 0, 0, 0.1)',
          borderRight: '0.5px solid rgba(0, 0, 0, 0.1)'
        }}
      >
        {/* Sidebar content */}
        {
          // <Box className={sidebar_opened ? `flex justify-center pt-[20px] px-[50px] pb-[20px]` : "h-[80px] flex justify-center items-center"} >
          //   <img
          //     className={sidebar_opened ? "h-[40px]" : "h-[28px]"}
          //     alt="Ripik Logo"
          //     src={sidebar_opened ? "./ripik-logo.png" : "./favicon.png"}
          //     height="40px"
          //   />
          // </Box>
        }
        <Box className="my-5">
          {
            sidebarItems.filter(item => !item.hidden && item?.roles?.includes(role)).map((item, idx) => <SidebarItem icon={item.icon} path={item.path} title={item.title} key={`sidebar-item-${item.path}-${idx}`} alternative_path={item?.alternative_path} only_icon={!sidebar_opened} />)
          }
          <Tooltip title={"User Guide"}>
            <Box
              className={`flex flex-row justify-start items-center px-3 py-[12px] gap-3 w-full cursor-pointer ${false ? 'primary-p10' : 'neutral-n10'
                }`}
              onClick={() => {
                const a = document.createElement("a");
                a.href = `${window.location?.origin}/user-guide`;
                a.target = "_blank";
                a?.click();
                a?.remove();
              }}
              sx={{
                bgcolor: false ? 'secondary.light' : '',
                ":hover": {
                  backgroundColor: 'secondary.light'
                }
              }}
            >
              <Box>{<MenuBookOutlined />}</Box>
              {
                sidebar_opened &&
                <Box className="text-center">
                  <Typography>{"User Guide"}</Typography>
                </Box>
              }
            </Box>
          </Tooltip>
        </Box>
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            width: "100%",
            // border:"1px solid red"
          }}>
          <Box className={`flex items-center ${sidebar_opened ? 'justify-start pl-[20px]' : 'justify-center'} gap-3 my-2`}>
            <Avatar sx={{ width: sidebar_opened ? '48px' : '24px', height: sidebar_opened ? '48px' : '24px' }} />
            {
              sidebar_opened &&
              <Typography textTransform="capitalize">Hi, {name}!</Typography>
            }
          </Box>
          <Divider variant='middle' />
          <Box className={`${sidebar_opened ? 'justify-start pl-[20px]' : 'justify-center'} my-2 flex items-center gap-3 ${auth_process_loading ? "text-gray-500" : "hover:text-red-500 hover:cursor-pointer"}`}
            onClick={() => {
              if (!auth_process_loading) {
                dispatch(logout_dispatch());
              }
            }}
          >
            {
              auth_process_loading && <CircularProgress size={20} color="inherit" />
            }
            <LogoutOutlined />
            {
              sidebar_opened &&
              <Typography>Logout</Typography>
            }
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Sidebar;